import { render, staticRenderFns } from "./ExportProducts.vue?vue&type=template&id=5d8f53e5&scoped=true&"
import script from "./ExportProducts.vue?vue&type=script&lang=js&"
export * from "./ExportProducts.vue?vue&type=script&lang=js&"
import style0 from "./ExportProducts.vue?vue&type=style&index=0&id=5d8f53e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8f53e5",
  null
  
)

export default component.exports